import { Component, OnInit } from '@angular/core';
import { AdminServiceService } from '../../service/admin-service.service';
import { UiService } from '../../service/ui.service';
import { CreateBankComponent } from '../create-bank/create-bank.component';

@Component({
  selector: 'app-account-banks',
  templateUrl: './account-banks.component.html',
  styleUrls: ['./account-banks.component.scss'],
})
export class AccountBanksComponent implements OnInit {
  banks:any [];
  constructor(
    private adminService: AdminServiceService,
    private uiService: UiService
  ) { }

  ngOnInit() {
    this.adminService.allBank().subscribe((res:any) => {
      this.banks = res.data
    })
  }

  async create(props = null){
    const { data, role } = await this.uiService.createModal(CreateBankComponent, { onEditCurrency: props});
    if(!data) return;
    if(role === 'create'){
      this.adminService.storeBank(data).subscribe((res:any) => {
        this.banks.unshift(res.data);
      })
    }else{
      this.adminService.updateBank({...data, id: props.id}).subscribe((res:any) => {
        this.banks = this.banks.filter(currencie => currencie.id !== props.id);
        this.banks.unshift(res.data);
      })
    }
  }

  async deleteCurrency(currencie?){
    const resModal = await this.uiService.presentAlert('Elminar moneda', `¿Deseas eliminar ${currencie.name}?.`);
    if(resModal.role === 'accept'){
      this.adminService.deleteBank(currencie).subscribe((res) => {
        this.banks = this.banks.filter(item => item.id !== currencie.id);
      })
    }
  }

}
